import {
  ComparisonChartTableProps,
  ComparisonChartTable,
} from "@/components/ComparisonChartTable";
import { FC, PropsWithChildren } from "react";

export const ComparisonChartBlock: FC<
  PropsWithChildren<ComparisonChartTableProps>
> = ({ children, ...props }) => (
  <ComparisonChartTable {...props}>{children}</ComparisonChartTable>
);
